/**
 * document
 * https://github.com/826327700/vue-photo-preview/blob/master/README.md
 */
import Vue from 'vue'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'

Vue.use(preview)
